import { styled } from "@acko-tech/building-blocks.ui.common";

export const Wrapper = styled.div`
  width: 100%;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 12px;
  padding: 20px 0;
  @media (min-width: 768px) {
    padding: 24px 0;
    grid-gap: 16px;
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const CardWrapper = styled.div`
  padding: 8px;
  text-align: center;
  border: 1px solid #e0e0e0;
  border-radius: 10px;

  ${(props) =>
    props.isSelected &&
    `
    border: 1px solid #0FA457;
  `}
`;

export const ImageWrapper = styled.div`
  height: 42px;
  border-radius: 8px;
  background: #f9f6ff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;

  ${(props) =>
    props.isSelected &&
    `
      background: rgb(235, 251, 238);
  `}
`;

export const CardLabel = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #040222;
  padding-top: 8px;
`;
